export default __webpack_public_path__ + "static/media/NotFound.35b52f76.png";